import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type CreateProposalInput = {
  accountName: Scalars['String']['input'];
  accountType: Scalars['String']['input'];
  attendees: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  hotelId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  segmentationType: Scalars['String']['input'];
  startDate: Scalars['Date']['input'];
};

/** A decoration object represents the model of a decoration that can be placed eather in a virtual space or in a furniture. */
export type Decoration = VirtualObject & {
  __typename?: 'Decoration';
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

/** A composition represents a set of virtual objects in a user defined pattern. */
export type FComposition = {
  __typename?: 'FComposition';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  schema: Scalars['JSON']['output'];
  type: FCompositionType;
};

/** A composition represents a set of virtual objects in a user defined pattern. */
export enum FCompositionType {
  Arrangement = 'Arrangement',
  Ensemble = 'Ensemble'
}

/** A furniture object represents the model of a furniture that can be placed in a virtual space. */
export type Furniture = VirtualObject & {
  __typename?: 'Furniture';
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new graph. */
  createGraph: ShallowGraph;
  /** Create a new proposal. */
  createProposal: Proposal;
  /** Update an existing graph. */
  updateGraph: ShallowGraph;
};


export type MutationCreateGraphArgs = {
  graph: ShallowGraphInput;
};


export type MutationCreateProposalArgs = {
  graph: ShallowGraphInput;
  input: CreateProposalInput;
};


export type MutationUpdateGraphArgs = {
  graph: ShallowGraphInput;
  id: Scalars['ID']['input'];
};

export type PaginatedResponse = {
  __typename?: 'PaginatedResponse';
  hasNext?: Maybe<Scalars['Boolean']['output']>;
};

export type Proposal = {
  __typename?: 'Proposal';
  accountName: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  attendees: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  email: Scalars['String']['output'];
  endDate: Scalars['Date']['output'];
  graph: ShallowGraph;
  hotelId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  segmentationType: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get a composition by its ID (nid). */
  fcomposition: FComposition;
  /** Get compositions by type. */
  fcompositions: Array<FComposition>;
  /** Get Schemas filtered by type */
  schemas: Array<Scalars['JSON']['output']>;
  /** Get a template by its ID. */
  templates: Array<Template>;
  /** Get a virtual object by its ID (nid). */
  virtualObject: VirtualObject;
  /** Get virtual objects by space ID and type. */
  virtualObjects: VirtualObjectsResponse;
  /** Get a virtual space by its ID (nid). */
  virtualSpace: VirtualSpace;
};


export type QueryFcompositionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFcompositionsArgs = {
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<FCompositionType>;
};


export type QuerySchemasArgs = {
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTemplatesArgs = {
  filters?: InputMaybe<TemplatesFiltersInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['ID']['input'];
};


export type QueryVirtualObjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVirtualObjectsArgs = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<VirtualObjectType>;
};


export type QueryVirtualSpaceArgs = {
  id: Scalars['ID']['input'];
};

/** Schema types */
export enum SchemaType {
  BoardroomArrangement = 'boardroom_arrangement',
  /** FArrangement types */
  TheaterArrangement = 'theater_arrangement'
}

export type ShallowGraph = {
  __typename?: 'ShallowGraph';
  cursor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nodes: Scalars['JSON']['output'];
  space: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type ShallowGraphInput = {
  cursor: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nodes: Scalars['JSON']['input'];
  space: Scalars['Int']['input'];
  version: Scalars['String']['input'];
};

export type Template = {
  __typename?: 'Template';
  description: Scalars['String']['output'];
  graph: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TemplatesFiltersInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** A virtual object represents the model of a furniture or decoration. */
export type VirtualObject = {
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
  type: VirtualObjectType;
};

/** The type of a virtual object. */
export enum VirtualObjectType {
  /** A decoration object. */
  Decoration = 'Decoration',
  /** A furniture object. */
  Furniture = 'Furniture'
}

export type VirtualObjectsResponse = {
  __typename?: 'VirtualObjectsResponse';
  data: Array<VirtualObject>;
  pagination: PaginatedResponse;
};

/** A virtual space represents a 3D model of a room or a space that can be decorated with virtual objects. */
export type VirtualSpace = {
  __typename?: 'VirtualSpace';
  hotel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nid?: Maybe<Scalars['Int']['output']>;
  placeholder: Scalars['String']['output'];
};

export type CreateGraphMutationVariables = Exact<{
  graph: ShallowGraphInput;
}>;


export type CreateGraphMutation = { __typename?: 'Mutation', createGraph: { __typename?: 'ShallowGraph', id: string, name: string, space: number, cursor?: string | null, nodes: any, version: string } };

export type CreateProposalMutationVariables = Exact<{
  input: CreateProposalInput;
  graph: ShallowGraphInput;
}>;


export type CreateProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', id: string, accountName: string, accountType: string, attendees: number, description: string, email: string, segmentationType: string, phoneNumber: string, endDate: any, startDate: any, hotelId: string, graph: { __typename?: 'ShallowGraph', id: string, name: string, space: number, cursor?: string | null, nodes: any, version: string } } };

export type UpdateGraphMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  graph: ShallowGraphInput;
}>;


export type UpdateGraphMutation = { __typename?: 'Mutation', updateGraph: { __typename?: 'ShallowGraph', id: string, name: string, space: number, cursor?: string | null, nodes: any, version: string } };

export type GetFCompositionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFCompositionQuery = { __typename?: 'Query', fcomposition: { __typename?: 'FComposition', id: string, nid: number, type: FCompositionType, name: string, schema: any } };

export type GetFCompositionsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<FCompositionType>;
}>;


export type GetFCompositionsQuery = { __typename?: 'Query', fcompositions: Array<{ __typename?: 'FComposition', id: string, nid: number, type: FCompositionType, name: string }> };

export type GetSchemasQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSchemasQuery = { __typename?: 'Query', schemas: Array<any> };

export type GetTemplatesQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  filters?: InputMaybe<TemplatesFiltersInput>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTemplatesQuery = { __typename?: 'Query', templates: Array<{ __typename?: 'Template', id: string, name: string, description: string, graph: any }> };

export type GetVirtualObjectQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVirtualObjectQuery = { __typename?: 'Query', virtualObject: { __typename?: 'Decoration', id: string, nid: number, name: string, model: string, type: VirtualObjectType, thumbnail?: string | null } | { __typename?: 'Furniture', id: string, nid: number, name: string, model: string, type: VirtualObjectType, thumbnail?: string | null } };

export type GetVirtualObjectsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  type?: InputMaybe<VirtualObjectType>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVirtualObjectsQuery = { __typename?: 'Query', virtualObjects: { __typename?: 'VirtualObjectsResponse', data: Array<{ __typename?: 'Decoration', id: string, nid: number, name: string, model: string, type: VirtualObjectType, objectType: string, thumbnail?: string | null } | { __typename?: 'Furniture', id: string, nid: number, name: string, model: string, type: VirtualObjectType, objectType: string, thumbnail?: string | null }>, pagination: { __typename?: 'PaginatedResponse', hasNext?: boolean | null } } };

export type GetVirtualObjectsAndFCompositionsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  objectType?: InputMaybe<VirtualObjectType>;
  fcompositionType?: InputMaybe<FCompositionType>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVirtualObjectsAndFCompositionsQuery = { __typename?: 'Query', virtualObjects: { __typename?: 'VirtualObjectsResponse', data: Array<{ __typename?: 'Decoration', id: string, nid: number, name: string, model: string, type: VirtualObjectType, objectType: string, thumbnail?: string | null } | { __typename?: 'Furniture', id: string, nid: number, name: string, model: string, type: VirtualObjectType, objectType: string, thumbnail?: string | null }>, pagination: { __typename?: 'PaginatedResponse', hasNext?: boolean | null } }, fcompositions: Array<{ __typename?: 'FComposition', id: string, nid: number, type: FCompositionType, name: string, schema: any }> };

export type GetVirtualSpaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVirtualSpaceQuery = { __typename?: 'Query', virtualSpace: { __typename?: 'VirtualSpace', id: string, nid?: number | null, model: string, placeholder: string, name: string, hotel: string } };


export const CreateGraphDocument = gql`
    mutation CreateGraph($graph: ShallowGraphInput!) {
  createGraph(graph: $graph) {
    id
    name
    space
    cursor
    nodes
    version
  }
}
    `;
export type CreateGraphMutationFn = Apollo.MutationFunction<CreateGraphMutation, CreateGraphMutationVariables>;

/**
 * __useCreateGraphMutation__
 *
 * To run a mutation, you first call `useCreateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGraphMutation, { data, loading, error }] = useCreateGraphMutation({
 *   variables: {
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useCreateGraphMutation(baseOptions?: Apollo.MutationHookOptions<CreateGraphMutation, CreateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGraphMutation, CreateGraphMutationVariables>(CreateGraphDocument, options);
      }
export type CreateGraphMutationHookResult = ReturnType<typeof useCreateGraphMutation>;
export type CreateGraphMutationResult = Apollo.MutationResult<CreateGraphMutation>;
export type CreateGraphMutationOptions = Apollo.BaseMutationOptions<CreateGraphMutation, CreateGraphMutationVariables>;
export const CreateProposalDocument = gql`
    mutation CreateProposal($input: CreateProposalInput!, $graph: ShallowGraphInput!) {
  createProposal(input: $input, graph: $graph) {
    id
    accountName
    accountType
    attendees
    description
    email
    segmentationType
    phoneNumber
    endDate
    startDate
    hotelId
    graph {
      id
      name
      space
      cursor
      nodes
      version
    }
  }
}
    `;
export type CreateProposalMutationFn = Apollo.MutationFunction<CreateProposalMutation, CreateProposalMutationVariables>;

/**
 * __useCreateProposalMutation__
 *
 * To run a mutation, you first call `useCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalMutation, { data, loading, error }] = useCreateProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalMutation, CreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalMutation, CreateProposalMutationVariables>(CreateProposalDocument, options);
      }
export type CreateProposalMutationHookResult = ReturnType<typeof useCreateProposalMutation>;
export type CreateProposalMutationResult = Apollo.MutationResult<CreateProposalMutation>;
export type CreateProposalMutationOptions = Apollo.BaseMutationOptions<CreateProposalMutation, CreateProposalMutationVariables>;
export const UpdateGraphDocument = gql`
    mutation UpdateGraph($id: ID!, $graph: ShallowGraphInput!) {
  updateGraph(id: $id, graph: $graph) {
    id
    name
    space
    cursor
    nodes
    version
  }
}
    `;
export type UpdateGraphMutationFn = Apollo.MutationFunction<UpdateGraphMutation, UpdateGraphMutationVariables>;

/**
 * __useUpdateGraphMutation__
 *
 * To run a mutation, you first call `useUpdateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGraphMutation, { data, loading, error }] = useUpdateGraphMutation({
 *   variables: {
 *      id: // value for 'id'
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useUpdateGraphMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGraphMutation, UpdateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGraphMutation, UpdateGraphMutationVariables>(UpdateGraphDocument, options);
      }
export type UpdateGraphMutationHookResult = ReturnType<typeof useUpdateGraphMutation>;
export type UpdateGraphMutationResult = Apollo.MutationResult<UpdateGraphMutation>;
export type UpdateGraphMutationOptions = Apollo.BaseMutationOptions<UpdateGraphMutation, UpdateGraphMutationVariables>;
export const GetFCompositionDocument = gql`
    query GetFComposition($id: ID!) {
  fcomposition(id: $id) {
    id
    nid
    type
    name
    schema
  }
}
    `;

/**
 * __useGetFCompositionQuery__
 *
 * To run a query within a React component, call `useGetFCompositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFCompositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFCompositionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFCompositionQuery(baseOptions: Apollo.QueryHookOptions<GetFCompositionQuery, GetFCompositionQueryVariables> & ({ variables: GetFCompositionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFCompositionQuery, GetFCompositionQueryVariables>(GetFCompositionDocument, options);
      }
export function useGetFCompositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFCompositionQuery, GetFCompositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFCompositionQuery, GetFCompositionQueryVariables>(GetFCompositionDocument, options);
        }
export function useGetFCompositionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFCompositionQuery, GetFCompositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFCompositionQuery, GetFCompositionQueryVariables>(GetFCompositionDocument, options);
        }
export type GetFCompositionQueryHookResult = ReturnType<typeof useGetFCompositionQuery>;
export type GetFCompositionLazyQueryHookResult = ReturnType<typeof useGetFCompositionLazyQuery>;
export type GetFCompositionSuspenseQueryHookResult = ReturnType<typeof useGetFCompositionSuspenseQuery>;
export type GetFCompositionQueryResult = Apollo.QueryResult<GetFCompositionQuery, GetFCompositionQueryVariables>;
export const GetFCompositionsDocument = gql`
    query GetFCompositions($spaceId: ID!, $type: FCompositionType) {
  fcompositions(spaceId: $spaceId, type: $type) {
    id
    nid
    type
    name
  }
}
    `;

/**
 * __useGetFCompositionsQuery__
 *
 * To run a query within a React component, call `useGetFCompositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFCompositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFCompositionsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetFCompositionsQuery(baseOptions: Apollo.QueryHookOptions<GetFCompositionsQuery, GetFCompositionsQueryVariables> & ({ variables: GetFCompositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFCompositionsQuery, GetFCompositionsQueryVariables>(GetFCompositionsDocument, options);
      }
export function useGetFCompositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFCompositionsQuery, GetFCompositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFCompositionsQuery, GetFCompositionsQueryVariables>(GetFCompositionsDocument, options);
        }
export function useGetFCompositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFCompositionsQuery, GetFCompositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFCompositionsQuery, GetFCompositionsQueryVariables>(GetFCompositionsDocument, options);
        }
export type GetFCompositionsQueryHookResult = ReturnType<typeof useGetFCompositionsQuery>;
export type GetFCompositionsLazyQueryHookResult = ReturnType<typeof useGetFCompositionsLazyQuery>;
export type GetFCompositionsSuspenseQueryHookResult = ReturnType<typeof useGetFCompositionsSuspenseQuery>;
export type GetFCompositionsQueryResult = Apollo.QueryResult<GetFCompositionsQuery, GetFCompositionsQueryVariables>;
export const GetSchemasDocument = gql`
    query GetSchemas($spaceId: ID!, $type: String) {
  schemas(spaceId: $spaceId, type: $type)
}
    `;

/**
 * __useGetSchemasQuery__
 *
 * To run a query within a React component, call `useGetSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchemasQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSchemasQuery(baseOptions: Apollo.QueryHookOptions<GetSchemasQuery, GetSchemasQueryVariables> & ({ variables: GetSchemasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchemasQuery, GetSchemasQueryVariables>(GetSchemasDocument, options);
      }
export function useGetSchemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchemasQuery, GetSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchemasQuery, GetSchemasQueryVariables>(GetSchemasDocument, options);
        }
export function useGetSchemasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchemasQuery, GetSchemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchemasQuery, GetSchemasQueryVariables>(GetSchemasDocument, options);
        }
export type GetSchemasQueryHookResult = ReturnType<typeof useGetSchemasQuery>;
export type GetSchemasLazyQueryHookResult = ReturnType<typeof useGetSchemasLazyQuery>;
export type GetSchemasSuspenseQueryHookResult = ReturnType<typeof useGetSchemasSuspenseQuery>;
export type GetSchemasQueryResult = Apollo.QueryResult<GetSchemasQuery, GetSchemasQueryVariables>;
export const GetTemplatesDocument = gql`
    query GetTemplates($spaceId: ID!, $filters: TemplatesFiltersInput, $sort: String) {
  templates(spaceId: $spaceId, filters: $filters, sort: $sort) {
    id
    name
    description
    graph
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables> & ({ variables: GetTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesSuspenseQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetVirtualObjectDocument = gql`
    query GetVirtualObject($id: ID!) {
  virtualObject(id: $id) {
    id
    nid
    name
    model
    type
    thumbnail
  }
}
    `;

/**
 * __useGetVirtualObjectQuery__
 *
 * To run a query within a React component, call `useGetVirtualObjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualObjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualObjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVirtualObjectQuery(baseOptions: Apollo.QueryHookOptions<GetVirtualObjectQuery, GetVirtualObjectQueryVariables> & ({ variables: GetVirtualObjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>(GetVirtualObjectDocument, options);
      }
export function useGetVirtualObjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>(GetVirtualObjectDocument, options);
        }
export function useGetVirtualObjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>(GetVirtualObjectDocument, options);
        }
export type GetVirtualObjectQueryHookResult = ReturnType<typeof useGetVirtualObjectQuery>;
export type GetVirtualObjectLazyQueryHookResult = ReturnType<typeof useGetVirtualObjectLazyQuery>;
export type GetVirtualObjectSuspenseQueryHookResult = ReturnType<typeof useGetVirtualObjectSuspenseQuery>;
export type GetVirtualObjectQueryResult = Apollo.QueryResult<GetVirtualObjectQuery, GetVirtualObjectQueryVariables>;
export const GetVirtualObjectsDocument = gql`
    query GetVirtualObjects($spaceId: ID!, $type: VirtualObjectType, $pageNumber: Int) {
  virtualObjects(spaceId: $spaceId, type: $type, pageNumber: $pageNumber) {
    data {
      id
      nid
      name
      model
      type
      objectType
      thumbnail
    }
    pagination {
      hasNext
    }
  }
}
    `;

/**
 * __useGetVirtualObjectsQuery__
 *
 * To run a query within a React component, call `useGetVirtualObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualObjectsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      type: // value for 'type'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetVirtualObjectsQuery(baseOptions: Apollo.QueryHookOptions<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables> & ({ variables: GetVirtualObjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>(GetVirtualObjectsDocument, options);
      }
export function useGetVirtualObjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>(GetVirtualObjectsDocument, options);
        }
export function useGetVirtualObjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>(GetVirtualObjectsDocument, options);
        }
export type GetVirtualObjectsQueryHookResult = ReturnType<typeof useGetVirtualObjectsQuery>;
export type GetVirtualObjectsLazyQueryHookResult = ReturnType<typeof useGetVirtualObjectsLazyQuery>;
export type GetVirtualObjectsSuspenseQueryHookResult = ReturnType<typeof useGetVirtualObjectsSuspenseQuery>;
export type GetVirtualObjectsQueryResult = Apollo.QueryResult<GetVirtualObjectsQuery, GetVirtualObjectsQueryVariables>;
export const GetVirtualObjectsAndFCompositionsDocument = gql`
    query GetVirtualObjectsAndFCompositions($spaceId: ID!, $objectType: VirtualObjectType, $fcompositionType: FCompositionType, $pageNumber: Int) {
  virtualObjects(spaceId: $spaceId, type: $objectType, pageNumber: $pageNumber) {
    data {
      id
      nid
      name
      model
      type
      objectType
      thumbnail
    }
    pagination {
      hasNext
    }
  }
  fcompositions(spaceId: $spaceId, type: $fcompositionType) {
    id
    nid
    type
    name
    schema
  }
}
    `;

/**
 * __useGetVirtualObjectsAndFCompositionsQuery__
 *
 * To run a query within a React component, call `useGetVirtualObjectsAndFCompositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualObjectsAndFCompositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualObjectsAndFCompositionsQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      objectType: // value for 'objectType'
 *      fcompositionType: // value for 'fcompositionType'
 *      pageNumber: // value for 'pageNumber'
 *   },
 * });
 */
export function useGetVirtualObjectsAndFCompositionsQuery(baseOptions: Apollo.QueryHookOptions<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables> & ({ variables: GetVirtualObjectsAndFCompositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>(GetVirtualObjectsAndFCompositionsDocument, options);
      }
export function useGetVirtualObjectsAndFCompositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>(GetVirtualObjectsAndFCompositionsDocument, options);
        }
export function useGetVirtualObjectsAndFCompositionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>(GetVirtualObjectsAndFCompositionsDocument, options);
        }
export type GetVirtualObjectsAndFCompositionsQueryHookResult = ReturnType<typeof useGetVirtualObjectsAndFCompositionsQuery>;
export type GetVirtualObjectsAndFCompositionsLazyQueryHookResult = ReturnType<typeof useGetVirtualObjectsAndFCompositionsLazyQuery>;
export type GetVirtualObjectsAndFCompositionsSuspenseQueryHookResult = ReturnType<typeof useGetVirtualObjectsAndFCompositionsSuspenseQuery>;
export type GetVirtualObjectsAndFCompositionsQueryResult = Apollo.QueryResult<GetVirtualObjectsAndFCompositionsQuery, GetVirtualObjectsAndFCompositionsQueryVariables>;
export const GetVirtualSpaceDocument = gql`
    query GetVirtualSpace($id: ID!) {
  virtualSpace(id: $id) {
    id
    nid
    model
    placeholder
    name
    hotel
  }
}
    `;

/**
 * __useGetVirtualSpaceQuery__
 *
 * To run a query within a React component, call `useGetVirtualSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVirtualSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVirtualSpaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVirtualSpaceQuery(baseOptions: Apollo.QueryHookOptions<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables> & ({ variables: GetVirtualSpaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>(GetVirtualSpaceDocument, options);
      }
export function useGetVirtualSpaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>(GetVirtualSpaceDocument, options);
        }
export function useGetVirtualSpaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>(GetVirtualSpaceDocument, options);
        }
export type GetVirtualSpaceQueryHookResult = ReturnType<typeof useGetVirtualSpaceQuery>;
export type GetVirtualSpaceLazyQueryHookResult = ReturnType<typeof useGetVirtualSpaceLazyQuery>;
export type GetVirtualSpaceSuspenseQueryHookResult = ReturnType<typeof useGetVirtualSpaceSuspenseQuery>;
export type GetVirtualSpaceQueryResult = Apollo.QueryResult<GetVirtualSpaceQuery, GetVirtualSpaceQueryVariables>;
export type DecorationKeySpecifier = ('id' | 'model' | 'name' | 'nid' | 'objectType' | 'thumbnail' | 'type' | DecorationKeySpecifier)[];
export type DecorationFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nid?: FieldPolicy<any> | FieldReadFunction<any>,
	objectType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FCompositionKeySpecifier = ('id' | 'name' | 'nid' | 'schema' | 'type' | FCompositionKeySpecifier)[];
export type FCompositionFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nid?: FieldPolicy<any> | FieldReadFunction<any>,
	schema?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FurnitureKeySpecifier = ('id' | 'model' | 'name' | 'nid' | 'objectType' | 'thumbnail' | 'type' | FurnitureKeySpecifier)[];
export type FurnitureFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nid?: FieldPolicy<any> | FieldReadFunction<any>,
	objectType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('createGraph' | 'createProposal' | 'updateGraph' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	createGraph?: FieldPolicy<any> | FieldReadFunction<any>,
	createProposal?: FieldPolicy<any> | FieldReadFunction<any>,
	updateGraph?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PaginatedResponseKeySpecifier = ('hasNext' | PaginatedResponseKeySpecifier)[];
export type PaginatedResponseFieldPolicy = {
	hasNext?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProposalKeySpecifier = ('accountName' | 'accountType' | 'attendees' | 'description' | 'email' | 'endDate' | 'graph' | 'hotelId' | 'id' | 'phoneNumber' | 'segmentationType' | 'startDate' | ProposalKeySpecifier)[];
export type ProposalFieldPolicy = {
	accountName?: FieldPolicy<any> | FieldReadFunction<any>,
	accountType?: FieldPolicy<any> | FieldReadFunction<any>,
	attendees?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	endDate?: FieldPolicy<any> | FieldReadFunction<any>,
	graph?: FieldPolicy<any> | FieldReadFunction<any>,
	hotelId?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	phoneNumber?: FieldPolicy<any> | FieldReadFunction<any>,
	segmentationType?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('fcomposition' | 'fcompositions' | 'schemas' | 'templates' | 'virtualObject' | 'virtualObjects' | 'virtualSpace' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	fcomposition?: FieldPolicy<any> | FieldReadFunction<any>,
	fcompositions?: FieldPolicy<any> | FieldReadFunction<any>,
	schemas?: FieldPolicy<any> | FieldReadFunction<any>,
	templates?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualObject?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualObjects?: FieldPolicy<any> | FieldReadFunction<any>,
	virtualSpace?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ShallowGraphKeySpecifier = ('cursor' | 'id' | 'name' | 'nodes' | 'space' | 'version' | ShallowGraphKeySpecifier)[];
export type ShallowGraphFieldPolicy = {
	cursor?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nodes?: FieldPolicy<any> | FieldReadFunction<any>,
	space?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TemplateKeySpecifier = ('description' | 'graph' | 'id' | 'name' | TemplateKeySpecifier)[];
export type TemplateFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	graph?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VirtualObjectKeySpecifier = ('id' | 'model' | 'name' | 'nid' | 'objectType' | 'thumbnail' | 'type' | VirtualObjectKeySpecifier)[];
export type VirtualObjectFieldPolicy = {
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nid?: FieldPolicy<any> | FieldReadFunction<any>,
	objectType?: FieldPolicy<any> | FieldReadFunction<any>,
	thumbnail?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VirtualObjectsResponseKeySpecifier = ('data' | 'pagination' | VirtualObjectsResponseKeySpecifier)[];
export type VirtualObjectsResponseFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>,
	pagination?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VirtualSpaceKeySpecifier = ('hotel' | 'id' | 'model' | 'name' | 'nid' | 'placeholder' | VirtualSpaceKeySpecifier)[];
export type VirtualSpaceFieldPolicy = {
	hotel?: FieldPolicy<any> | FieldReadFunction<any>,
	id?: FieldPolicy<any> | FieldReadFunction<any>,
	model?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nid?: FieldPolicy<any> | FieldReadFunction<any>,
	placeholder?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	Decoration?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DecorationKeySpecifier | (() => undefined | DecorationKeySpecifier),
		fields?: DecorationFieldPolicy,
	},
	FComposition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FCompositionKeySpecifier | (() => undefined | FCompositionKeySpecifier),
		fields?: FCompositionFieldPolicy,
	},
	Furniture?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FurnitureKeySpecifier | (() => undefined | FurnitureKeySpecifier),
		fields?: FurnitureFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	PaginatedResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PaginatedResponseKeySpecifier | (() => undefined | PaginatedResponseKeySpecifier),
		fields?: PaginatedResponseFieldPolicy,
	},
	Proposal?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProposalKeySpecifier | (() => undefined | ProposalKeySpecifier),
		fields?: ProposalFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	ShallowGraph?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ShallowGraphKeySpecifier | (() => undefined | ShallowGraphKeySpecifier),
		fields?: ShallowGraphFieldPolicy,
	},
	Template?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TemplateKeySpecifier | (() => undefined | TemplateKeySpecifier),
		fields?: TemplateFieldPolicy,
	},
	VirtualObject?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VirtualObjectKeySpecifier | (() => undefined | VirtualObjectKeySpecifier),
		fields?: VirtualObjectFieldPolicy,
	},
	VirtualObjectsResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VirtualObjectsResponseKeySpecifier | (() => undefined | VirtualObjectsResponseKeySpecifier),
		fields?: VirtualObjectsResponseFieldPolicy,
	},
	VirtualSpace?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VirtualSpaceKeySpecifier | (() => undefined | VirtualSpaceKeySpecifier),
		fields?: VirtualSpaceFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;